import BaseClass from './BaseClass';

export default class BaseService extends BaseClass {
  constructor(config) {
    super({ name: config.name, type: 'Service' });
  }
  sendClientRequest({ // eslint-disable-line class-methods-use-this
    client, settings, errorMsg, // eslint-disable-line no-unused-vars
  }) {
    return client.sendRequest(settings);
  }
}
